import styled from '@emotion/styled';

const NewTag = styled('span')`
    display: inline-flex;
    height: 20px;
    padding: 0px 4px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;

    border-radius: 6px;
    background: #ddf7e7;

    backdrop-filter: blur(12px);

    color: #0d7656;
    font-family: Manrope;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 8px;
`;

interface Props {
    className?: string;
    isNew?: boolean;
}
export const AvatarNewTag = ({ className, isNew = false }: Props) => {
    if (!isNew) {
        return null;
    }
    return <NewTag className={className}>New</NewTag>;
};
